import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { app_navbar_routes } from "../../../constants/app-navbar-routes";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../constants/enums";

const InternalStoreTransferTable = Loadable(
  lazy(() =>
    import("./InternalStoreTransferTable").then(
      ({ InternalStoreTransferTable }) => ({
        default: InternalStoreTransferTable,
      }),
    ),
  ),
);

export const internalStoreTransferRoutes = [
  {
    path: app_navbar_routes.app.grn.internal_store_transfer,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.INTERNAL_STORE_TRANSFER]}>
        <InternalStoreTransferTable />
      </AuthorizedRoute>
    ),
  },
];
